var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"presse"}},[_c('h1',{staticClass:"no-pad",domProps:{"innerHTML":_vm._s(_vm.subpages.title)}}),_vm._l((_vm.subpages.children),function(subpage){return _c('curator',{key:subpage.uid,attrs:{"post":subpage}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }